
import { inject, Injectable } from "@angular/core";
import { ApiService } from "./apiService";
import { IFormMetadata, ISearchableGridFormMetadata, TreeNode, Tuple } from "@tylertech/tyler-api-types";

/**
 * SetupViewService is a generated service implementation. Any edits will be overridden!
 */
@Injectable()
export class SetupViewService {
    private readonly $apiService = inject(ApiService);
    
    AllViewPaths(): Promise<TreeNode[]> {
        return this.$apiService.sendAuth("ISetupViewService/AllViewPaths");
    }
    AllViewPathsString(): Promise<string[]> {
        return this.$apiService.sendAuth("ISetupViewService/AllViewPathsString");
    }
    AllViewPathsStringByApp(): Promise<{ [key: string]: string[] }> {
        return this.$apiService.sendAuth("ISetupViewService/AllViewPathsStringByApp");
    }
    Get(filterString?: string): Promise<IFormMetadata[]> {
        return this.$apiService.sendAuth("ISetupViewService/Get", null, filterString);
    }
    GetByType(type: string, filterString?: string): Promise<IFormMetadata> {
        return this.$apiService.sendAuth("ISetupViewService/GetByType", type, filterString);
    }
    GetEditForm(pathAndType: Tuple<string, string>): Promise<IFormMetadata> {
        return this.$apiService.sendAuth("ISetupViewService/GetEditForm", pathAndType);
    }
    GetForm(path: string, filterString?: string): Promise<IFormMetadata> {
        return this.$apiService.sendAuth("ISetupViewService/GetForm", path, filterString);
    }
    GetFormAssembly(formPath: string): Promise<string> {
        return this.$apiService.sendAuth("ISetupViewService/GetFormAssembly", formPath);
    }
    GetPaths(filterString?: string): Promise<TreeNode[]> {
        return this.$apiService.sendAuth("ISetupViewService/GetPaths", null, filterString);
    }
    GetSearchableGridScreens(filterString?: string): Promise<ISearchableGridFormMetadata[]> {
        return this.$apiService.sendAuth("ISetupViewService/GetSearchableGridScreens", null, filterString);
    }
}
